<h4 *ngIf="data.title" mat-dialog-title>{{ data.title }}</h4>

<!-- Loading State -->
<div *ngIf="loading" class="loading-container d-flex justify-content-center align-items-center p-2">
    <span class="ms-3">Getting shop form...</span>
</div>

<!-- Main Content -->
<div mat-dialog-content *ngIf="!loading && isInitialized">
    <div class="shop-form-container">
        <form [formGroup]="form">
            <!-- Header Section - Shop Trip Information -->
            <div class="row">
                <!-- Left Column -->
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-2">
                            <mat-form-field class="w-100" floatLabel="always">
                                <mat-label>Car Init</mat-label>
                                <input matInput bdsShoutcase formControlName="carInit" readonly />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-4">
                            <mat-form-field class="w-100" floatLabel="always">
                                <mat-label>Car Number</mat-label>
                                <input matInput bdsShoutcase formControlName="carNo" readonly />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <bds-date-time-picker
                                formControlName="shipDateTime"
                                label="Shipment Date *"
                                [isValid]="true"
                                [readOnly]="true"
                                displayFormat="MM/dd/yyyy HH:mm"
                            ></bds-date-time-picker>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="w-100" floatLabel="always">
                                <mat-label>Current City</mat-label>
                                <input matInput bdsShoutcase formControlName="locCity" readonly />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-2">
                            <mat-form-field class="w-100" floatLabel="always">
                                <mat-label>State</mat-label>
                                <input matInput bdsShoutcase formControlName="locState" readonly />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="w-100" floatLabel="always">
                                <mat-label>Clean/Safe for Entry</mat-label>
                                <mat-select formControlName="cleanSafeEntry">
                                    <mat-option value="Y">YES</mat-option>
                                    <mat-option value="N">NO</mat-option>
                                    <mat-option value="V">UNDER VACUUM</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <!-- Right Column -->
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="w-100" floatLabel="always">
                                <mat-label>Fleet ID</mat-label>
                                <input matInput bdsShoutcase formControlName="fleetId" readonly />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="w-100" floatLabel="always">
                                <mat-label>Business Group</mat-label>
                                <input
                                    matInput
                                    bdsShoutcase
                                    formControlName="businessGroup"
                                    readonly
                                />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-9">
                            <mat-form-field class="w-100" floatLabel="always">
                                <mat-label>Product Name</mat-label>
                                <input
                                    matInput
                                    bdsShoutcase
                                    formControlName="productName"
                                    readonly
                                />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-3">
                            <mat-form-field class="w-100" floatLabel="always">
                                <mat-label>STCC</mat-label>
                                <input matInput bdsShoutcase formControlName="stcc" readonly />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="w-100" floatLabel="always">
                                <mat-label>Car Capacity</mat-label>
                                <input
                                    matInput
                                    bdsShoutcase
                                    formControlName="carCapacity"
                                    readonly
                                />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="w-100" floatLabel="always">
                                <mat-label>Last Product Code</mat-label>
                                <input
                                    matInput
                                    bdsShoutcase
                                    formControlName="lastCommCode"
                                    readonly
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <mat-form-field class="w-100" floatLabel="always">
                        <mat-label>Comments</mat-label>
                        <textarea
                            matInput
                            bdsShoutcase
                            formControlName="shopComments"
                            rows="4"
                        ></textarea>
                    </mat-form-field>
                </div>
            </div>

            <!-- Test Information Table -->
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th></th>
                        <th class="text-center">PREV</th>
                        <th class="text-center">DUE</th>
                        <th class="text-center">TYPE</th>
                        <th class="text-center">COND</th>
                        <th class="text-center">PREV</th>
                        <th class="text-center">DUE</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="fw-bold">Tank Test</td>
                        <td class="data-cell">
                            {{ form.get('prevTankTest')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('tankTestDue')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td></td>
                        <td class="data-cell">{{ form.get('date1FieldName')?.value }}</td>
                        <td class="data-cell">
                            {{ form.get('date1Prev')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('date1Due')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                    </tr>
                    <tr>
                        <td class="fw-bold">Valve Test</td>
                        <td class="data-cell">
                            {{ form.get('prevValveTest')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('valveTestDue')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">{{ form.get('valveType')?.value }}</td>
                        <td class="data-cell">{{ form.get('date2FieldName')?.value }}</td>
                        <td class="data-cell">
                            {{ form.get('date2Prev')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('date2Due')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                    </tr>
                    <tr>
                        <td class="fw-bold">Coil Test</td>
                        <td class="data-cell">
                            {{ form.get('prevCoilTest')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('coilTestDue')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">{{ form.get('coilType')?.value }}</td>
                        <td class="data-cell">{{ form.get('date3FieldName')?.value }}</td>
                        <td class="data-cell">
                            {{ form.get('date3Prev')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('date3Due')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                    </tr>
                    <tr>
                        <td class="fw-bold">Spark Test</td>
                        <td class="data-cell">
                            {{ form.get('prevSparkTest')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('sparkTestDue')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td></td>
                        <td class="data-cell">{{ form.get('date4FieldName')?.value }}</td>
                        <td class="data-cell">
                            {{ form.get('date4Prev')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('date4Due')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                    </tr>
                    <tr>
                        <td class="fw-bold">Stub Sill</td>
                        <td class="data-cell">
                            {{ form.get('prevStubSillTest')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('stubSillTestDue')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td></td>
                        <td class="data-cell">{{ form.get('date5FieldName')?.value }}</td>
                        <td class="data-cell">
                            {{ form.get('date5Prev')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('date5Due')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                    </tr>
                    <tr>
                        <td class="fw-bold">Paint</td>
                        <td class="data-cell">
                            {{ form.get('prevPaintDate')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('paintDue')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">{{ form.get('paintType')?.value }}</td>
                        <td class="data-cell">{{ form.get('date6FieldName')?.value }}</td>
                        <td class="data-cell">
                            {{ form.get('date6Prev')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('date6Due')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                    </tr>
                    <tr>
                        <td class="fw-bold">Lining</td>
                        <td class="data-cell">
                            {{ form.get('prevLiningDate')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('liningDue')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">{{ form.get('liningType')?.value }}</td>
                        <td class="data-cell">{{ form.get('date7FieldName')?.value }}</td>
                        <td class="data-cell">
                            {{ form.get('date7Prev')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('date7Due')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                    </tr>
                    <tr>
                        <td class="fw-bold">Lining Test</td>
                        <td class="data-cell">
                            {{ form.get('prevLiningTest')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('liningTestDue')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td></td>
                        <td class="data-cell">{{ form.get('date8FieldName')?.value }}</td>
                        <td class="data-cell">
                            {{ form.get('date8Prev')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('date8Due')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                    </tr>
                    <tr>
                        <td class="fw-bold">88 B2 Inspection</td>
                        <td class="data-cell">
                            {{ form.get('inspect88b2Prev')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('inspect88b2Due')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td></td>
                        <td class="data-cell">{{ form.get('date9FieldName')?.value }}</td>
                        <td class="data-cell">
                            {{ form.get('date9Prev')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('date9Due')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                    </tr>
                    <tr>
                        <td class="fw-bold">Shell Thickness</td>
                        <td class="data-cell">
                            {{ form.get('shellThicknessPrev')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('shellThicknessDue')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td></td>
                        <td class="data-cell">{{ form.get('date10FieldName')?.value }}</td>
                        <td class="data-cell">
                            {{ form.get('date10Prev')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('date10Due')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                    </tr>
                    <tr>
                        <td class="fw-bold">General Maint</td>
                        <td class="data-cell">
                            {{ form.get('lastMaintDate')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td class="data-cell">
                            {{ form.get('nextMaintDate')?.value | date : 'MM/dd/yyyy HH:mm' }}
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>

            <!-- Lease Info Section -->
            <h4 class="lease-info-header">LEASE INFO</h4>

            <div class="row">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="w-100" floatLabel="always">
                                <mat-label>Rider No.</mat-label>
                                <input
                                    matInput
                                    bdsShoutcase
                                    formControlName="lessorRiderNo"
                                    readonly
                                />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <mat-form-field class="w-100" floatLabel="always">
                                <mat-label>Shop Name</mat-label>
                                <input matInput bdsShoutcase formControlName="shopName" readonly />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <mat-form-field class="w-100" floatLabel="always">
                                <mat-label>Shop Location</mat-label>
                                <input
                                    matInput
                                    bdsShoutcase
                                    formControlName="shopLocation"
                                    readonly
                                />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <mat-form-field class="w-100" floatLabel="always">
                                <mat-label>Routing</mat-label>
                                <input matInput bdsShoutcase formControlName="routeCode" readonly />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-sm-12 mb-3">
                            <dx-date-box
                                name="lessorBeginDate"
                                class="w-100 bds-dx-custom-material bds-mat-dense-form-field dx-mat-form-field-floatLabel-always"
                                formControlName="lessorBeginDate"
                                [stylingMode]="'filled'"
                                type="datetime"
                                displayFormat="MM/dd/yyyy HH:mm"
                                dateSerializationFormat="yyyy-MM-dd HH:mm:ss"
                                [useMaskBehavior]="true"
                                label="Begin Date"
                            >
                            </dx-date-box>
                        </div>
                        <div class="col-sm-12">
                            <mat-form-field class="w-100" floatLabel="always">
                                <mat-label>Shop Contact</mat-label>
                                <input
                                    matInput
                                    bdsShoutcase
                                    formControlName="shopContact"
                                    readonly
                                />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <mat-form-field class="w-100" floatLabel="always">
                                <mat-label>Fax Number</mat-label>
                                <input matInput bdsShoutcase formControlName="faxNumber" readonly />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <mat-form-field class="w-100" floatLabel="always">
                                <mat-label>Email</mat-label>
                                <input
                                    matInput
                                    bdsShoutcase
                                    formControlName="email"
                                    type="email"
                                    readonly
                                />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <dx-date-box
                                name="lessorEndDate"
                                class="w-100 bds-dx-custom-material bds-mat-dense-form-field dx-mat-form-field-floatLabel-always"
                                formControlName="lessorEndDate"
                                [stylingMode]="'filled'"
                                type="datetime"
                                displayFormat="MM/dd/yyyy HH:mm"
                                dateSerializationFormat="yyyy-MM-dd HH:mm:ss"
                                [useMaskBehavior]="true"
                                label="End Date"
                            >
                            </dx-date-box>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <mat-form-field class="w-100" floatLabel="always">
                        <mat-label>Special Requirements</mat-label>
                        <textarea
                            matInput
                            bdsShoutcase
                            rows="4"
                            formControlName="specialRequirements"
                        ></textarea>
                    </mat-form-field>
                    <mat-form-field class="w-100" floatLabel="always">
                        <mat-label>Additional Comments</mat-label>
                        <textarea
                            matInput
                            bdsShoutcase
                            rows="4"
                            formControlName="additionalComments"
                        ></textarea>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>
</div>

<!-- Dialog Actions -->
<mat-dialog-actions align="end" *ngIf="!loading && isInitialized">
    <button mat-button class="text-uppercase" (click)="onCancel()" color="accent">Cancel</button>
    <button
        mat-button
        class="text-uppercase"
        color="primary"
        (click)="onSave()"
        [disabled]="form.invalid || loading"
    >
        Save
    </button>
</mat-dialog-actions>
